import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";
import USER_FORM_MESSAGES, { UserFormMessages } from "../users/user-form.messages";

export type ProfileMessages = UserFormMessages &
  SidebarMessages & {
    pageTitle: string;
    permissionsLabel: string;
    changePasswordLabel: string;
    profileLabel: string;
    passwordRequired: string;
    passwordFormatError: string;
    passwordNotMatching: string;
    newPasswordLabel: string;
    oldPasswordLabel: string;
    confirmPasswordLabel: string;
    newPasswordPlaceholder: string;
    oldPasswordPlaceholder: string;
    confirmPasswordPlaceholder: string;
    updatePasswordButton: string;
    updateUserSuccess: string;
    changePasswordSuccess: string;
    updateUserError: string;
    changePasswordError: string;
    changePassworTitle: string;
    changePasswordRequirements: string;
    changePasswordRequirementsDescription: string;
    changePasswordSpecialCharacterRule: string;
    changePasswordMinRule: string;
    changePasswordOneNumberRule: string;
    changePasswordLowerRule: string;
    changePasswordUpperRule: string;
    userNotFoundTitle: string;
    userNotFoundDescription: string;
    userErrorToLoadTitle: string;
    userNotFoundAlt: string;
    userKeyText: string;
    permissionErrorToLoadTitle: string;
    permissionsTitle: string;
    insertUserProfileSuccess: string;
    inserUserProfileError: string;
    cannotRemoveAdminPermission: string;
  };

export const PROFILE_MESSAGES: ProfileMessages = {
  pageTitle: "Perfil",
  permissionsLabel: "Permissões",
  changePasswordLabel: "Alterar senha",
  profileLabel: "Perfil",
  passwordRequired: "Campo obrigatório",
  passwordFormatError: "Senha inválida",
  passwordNotMatching: "Senhas não estão batendo",
  newPasswordLabel: "Senha nova",
  oldPasswordLabel: "Senha atual",
  confirmPasswordLabel: "Confirmação de senha",
  newPasswordPlaceholder: "Digite sua senha nova aqui",
  oldPasswordPlaceholder: "Digite sua senha atual aqui",
  confirmPasswordPlaceholder: "Digite sua confirmação de senha aqui",
  updatePasswordButton: "Salvar",
  updateUserSuccess: "Usuário atualizado com sucesso",
  changePasswordSuccess:
    "Senha alterada com sucesso! Faça o login novamente para utilizar a aplicação",
  updateUserError: "Erro ao alterar dados do usuário",
  changePasswordError: "Erro ao alterar senha",
  changePassworTitle: "Alterar senha",
  changePasswordRequirements: "Requisitos de senha",
  changePasswordRequirementsDescription: "Siga estes requisitos para ter uma senha forte",
  changePasswordSpecialCharacterRule: "Deve conter pelo menos 1 caractere especial",
  changePasswordMinRule: "Deve conter no mínimo 8 caracteres.",
  changePasswordOneNumberRule: "Deve conter pelo menos 1 caractere numérico",
  changePasswordLowerRule: "Deve conter pelo menos 1 caractere minúsculo",
  changePasswordUpperRule: "Deve conter pelo menos 1 caractere maiúsculo",
  userNotFoundTitle: "Usuário não encontrado",
  userNotFoundDescription:
    "Não conseguimos encontrar o usuário, recarregue a página e tente novamente",
  userErrorToLoadTitle: "Erro ao buscar usuário",
  userNotFoundAlt: "Imagem indicando erro ao buscar usuário",
  userKeyText: "Chave do usuário",
  permissionErrorToLoadTitle: "Erro ao buscas permissões",
  insertUserProfileSuccess: "Permissão alterada com sucesso",
  inserUserProfileError: "Erro ao alterar permissão",
  cannotRemoveAdminPermission: "Você não pode remover sua própria permissão de administrador.",

  ...USER_FORM_MESSAGES,
  ...SIDEBAR_MESSAGES,
};
